import {makeStyles} from "@material-ui/core";
import PropTypes from "prop-types";
import CustomButton from "./CustomButton";
import React from "react";
import clsx from "clsx";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
    actions: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "flex-end",
    },
    reverseActions: {
        flexDirection: "row-reverse",
        justifyContent: "flex-start",
    },
    firstButton: {
    },
    secondButton: {
        marginLeft: theme.spacing(2)
    }
}));

const CustomCTA = ({
    // Required props
    firstTitle,
    firstActionHandler,

    secondTitle,
    secondActionHandler,

    // Optional props
    containerClassNameOverride,
    firstSize,
    firstColor,
    firstVariant,
    firstClassNameOverride,
    firstDisableElevation,
    firstLoading,
    firstDisabled,
    firstE2eId,

    secondSize,
    secondColor,
    secondVariant,
    secondClassNameOverride,
    secondDisableElevation,
    secondLoading,
    secondDisabled,
    secondStartIcon,
    secondE2eId,

    // Changes the order of buttons on linebreak
    reverseMobileOrder,
}) => {
    const classes = useStyles();

    return(
        <div className={clsx(classes.actions,
            {[classes.reverseActions]: reverseMobileOrder},
            {[containerClassNameOverride]: containerClassNameOverride})}
        >
            <Box
                clone
                order={(reverseMobileOrder && 2) || 1}
            >
                <CustomButton
                    e2e-id={firstE2eId || ""}
                    variant={firstVariant}
                    className={clsx(classes.firstButton,
                        {[firstClassNameOverride]: firstClassNameOverride})}
                    size={firstSize}
                    color={firstColor}
                    onClick={firstActionHandler}
                    disableElevation={firstDisableElevation}
                    loading={firstLoading}
                    disabled={firstDisabled}
                >
                    {firstTitle}
                </CustomButton>
            </Box>

            <Box
                clone
                order={(reverseMobileOrder && 1) || 2}
            >
                <CustomButton
                    variant={secondVariant}
                    className={clsx(classes.secondButton,
                        {[secondClassNameOverride]: secondClassNameOverride})}
                    size={secondSize}
                    color={secondColor}
                    onClick={secondActionHandler}
                    disableElevation={secondDisableElevation}
                    loading={secondLoading}
                    disabled={secondDisabled}
                    startIcon={secondStartIcon}
                    e2e-id={secondE2eId || ""}
                >
                    {secondTitle}
                </CustomButton>
            </Box>
        </div>
    );

};


CustomCTA.defaultProps = {
    firstSize: "large",
    firstVariant: "outlined",
    firstDisableElevation: false,
    firstLoading: false,
    firstDisabled: false,

    secondSize: "large",
    secondVariant: "contained",
    secondDisableElevation: true,
    secondLoading: false,
    secondDisabled: false,

    reverseMobileOrder: false,
};

CustomCTA.propTypes = {
    // Required Properties
    firstTitle: PropTypes.string.isRequired,
    firstActionHandler: PropTypes.any.isRequired,

    secondTitle: PropTypes.string.isRequired,
    secondActionHandler: PropTypes.any.isRequired,

    // Optional Properties
    containerClassNameOverride: PropTypes.string,
    firstSize: PropTypes.string,
    firstColor: PropTypes.string,
    firstVariant: PropTypes.string,
    firstClassNameOverride: PropTypes.string,
    firstDisableElevation: PropTypes.bool,
    firstLoading: PropTypes.bool,
    firstDisabled: PropTypes.bool,
    firstE2eId: PropTypes.string,

    secondSize: PropTypes.string,
    secondVariant: PropTypes.string,
    secondColor: PropTypes.string,
    secondClassNameOverride: PropTypes.string,
    secondDisableElevation: PropTypes.bool,
    secondLoading: PropTypes.bool,
    secondDisabled: PropTypes.bool,
    secondStartIcon: PropTypes.object,

    reverseMobileOrder: PropTypes.bool,
    secondE2eId: PropTypes.string
};

export default CustomCTA;
